<script>
export default {
  data() {
    return {
      isFullscreen: false,
    }
  },
  methods: {
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
  }
};
</script>

<style>
.fullscreen-container.fullscreen {
  position: fixed;
  overflow: auto;
  padding: 1rem;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
}
</style>

<template>
  <div class="fullscreen-container bg-white" :class="{ fullscreen: isFullscreen }">
    <div class="text-end mb-2">
      <button @click="toggleFullscreen" class="btn btn-outline-secondary">
        <span v-if="!isFullscreen" class="bi bi-arrows-fullscreen"></span>
        <span v-else class="bi bi-fullscreen-exit"></span>
      </button>
    </div>
    <slot></slot>
  </div>
</template>